(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8455],{

/***/ 96033:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact-us",
      function () {
        return __webpack_require__(1912);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 78763:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$0": function() { return /* binding */ Section; },
/* harmony export */   "$C": function() { return /* binding */ ModuleTitle; },
/* harmony export */   "Dx": function() { return /* binding */ Title; },
/* harmony export */   "Pu": function() { return /* binding */ CenterOnSmallScreen; },
/* harmony export */   "VY": function() { return /* binding */ Content; },
/* harmony export */   "xv": function() { return /* binding */ Text; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19521);
/* harmony import */ var _colors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22745);
/* harmony import */ var _mixins__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52873);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      padding: 3rem 0;\n\n      ",
        " {\n        font-size: 24px;\n        margin-bottom: 3rem;\n        text-align: center;\n\n        &::after {\n          left: 50%;\n          bottom: -10px;\n          margin-left: -1.5rem;\n        }\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  background: ",
        ";\n  padding: 4rem 0 6rem;\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n  width: 100%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  font-size: 32px;\n  margin-bottom: 4rem;\n\n  && {\n    font-weight: normal;\n  }\n\n  &::after {\n    ",
        ";\n    content: '';\n    background: ",
        ";\n    position: absolute;\n    bottom: -6px;\n    left: 0;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n      justify-content: ",
        ";\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n  justify-content: space-between;\n  line-height: 1;\n  font-size: 20px;\n  font-weight: normal !important;\n  margin-bottom: 2rem;\n\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 16px;\n  color: ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n      ",
        "\n      text-align: center;\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}



var Section = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(_templateObject1(), _colors__WEBPACK_IMPORTED_MODULE_1__.F1, _colors__WEBPACK_IMPORTED_MODULE_1__.M1, function(props) {
    return props.isSmallScreen && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(_templateObject(), Title);
});
var Content = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(_templateObject2(), _mixins__WEBPACK_IMPORTED_MODULE_2__/* .responsive */ .jW());
var Title = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].h2 */ .ZP.h2(_templateObject3(), _mixins__WEBPACK_IMPORTED_MODULE_2__/* .size */ .dp("3rem", "10px"), _colors__WEBPACK_IMPORTED_MODULE_1__.B1);
var ModuleTitle = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].h3 */ .ZP.h3(_templateObject5(), _mixins__WEBPACK_IMPORTED_MODULE_2__/* .flexVerticalCenter */ .VL(), function(props) {
    return props.justify && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(_templateObject4(), props.justify);
});
var Text = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(_templateObject6(), _colors__WEBPACK_IMPORTED_MODULE_1__.F2);
var CenterOnSmallScreen = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(_templateObject8(), function(props) {
    return props.isSmallScreen && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(_templateObject7(), _mixins__WEBPACK_IMPORTED_MODULE_2__/* .centerBlock */ .EM());
});


/***/ }),

/***/ 580:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Anchor; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


function Anchor(_param) {
    var target = _param.target, rel = _param.rel, isHash = _param.isHash, rest = _objectWithoutProperties(_param, [
        "target",
        "rel",
        "isHash"
    ]);
    var props = _objectSpread({}, rest);
    //const isInternalLink = rest.href.charAt(0) === '/'
    //const hasHash = props.href.includes('#') && isInternalLink
    props.target = isHash ? "" : target !== null && target !== void 0 ? target : "_blank";
    props.rel = isHash ? "" : rel !== null && rel !== void 0 ? rel : "noopener noreferrer";
    var _children;
    var children = (_children = props.children) !== null && _children !== void 0 ? _children : props.href;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", _objectSpread({}, props, {
        children: children
    }));
};


/***/ }),

/***/ 1912:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ index_page; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/components/index.js + 20 modules
var components = __webpack_require__(21679);
// EXTERNAL MODULE: ./src/components/Anchor.tsx
var Anchor = __webpack_require__(580);
// EXTERNAL MODULE: ./src/layouts/index.js + 13 modules
var layouts = __webpack_require__(59269);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./packages/ui/src/styled.ts
var styled = __webpack_require__(78763);
// EXTERNAL MODULE: ./packages/ui/src/colors.ts
var colors = __webpack_require__(22745);
// EXTERNAL MODULE: ./packages/ui/src/mixins.ts
var mixins = __webpack_require__(52873);
// EXTERNAL MODULE: ./node_modules/antd/es/space/index.js + 1 modules
var space = __webpack_require__(26713);
;// CONCATENATED MODULE: ./src/pages/contact-us/index.styled.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  //align-items: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  background: ",
        ";\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    //   width: calc(966px - 2rem);\n    //\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n    //   width: auto;\n    //\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 24px;\n  color: #2c2c2c;\n  margin-top: 2rem;\n  // ",
        ";\n  // ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n    flex-direction: row;\n    align-items: flex-start;\n    & > div {\n      &:not(:last-child) {\n        margin-right: 2rem;\n      }\n    }\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n    flex-direction: column;\n    align-items: center;\n    & > div {\n      &:not(:last-child) {\n        margin-bottom: 2rem;\n      }\n    }\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  ",
        ";\n  ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n  background-color: #fff;\n  border-top: 4px solid ",
        ";\n  border-bottom: 4px solid ",
        ";\n  //margin: 1rem;\n  padding: 1.75rem;\n  border-radius: 4px;\n  overflow: hidden;\n  width: 280px;\n  height: 330px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 20px;\n  color: #2c2c2c;\n  margin-bottom: 1rem;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: 1.5rem;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 16px;\n  color: #565656;\n  margin-bottom: 0.5rem;\n  a {\n    //color: ",
        ";\n    font-size: 16px;\n    color: #be1d32;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 12px;\n  margin-bottom: 0.5rem;\n  color: gray;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: 4rem;\n  margin-bottom: -8px;\n  text-align: center;\n  img {\n    width: 100%;\n    max-width: 600px;\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}



var Content = (0,styled_components_browser_esm/* default */.ZP)(styled/* Content */.VY)(_templateObject());
var Container = styled_components_browser_esm/* default.div */.ZP.div(_templateObject1(), colors.M2);
var Title = styled_components_browser_esm/* default.h1 */.ZP.h1(_templateObject4(), mixins/* onDesktop */.X$((0,styled_components_browser_esm/* css */.iv)(_templateObject2())), mixins/* onMobile */.vA((0,styled_components_browser_esm/* css */.iv)(_templateObject3())));
var List = (0,styled_components_browser_esm/* default */.ZP)(space/* default */.Z)(_templateObject7(), mixins/* onDesktop */.X$((0,styled_components_browser_esm/* css */.iv)(_templateObject5())), mixins/* onMobile */.vA((0,styled_components_browser_esm/* css */.iv)(_templateObject6())));
var Card = styled_components_browser_esm/* default.div */.ZP.div(_templateObject8(), mixins/* boxShadow */.Wn(), function(props) {
    return props.$color;
}, function(props) {
    return props.$color;
});
var CardTitle = styled_components_browser_esm/* default.h2 */.ZP.h2(_templateObject9());
var CardGroup = styled_components_browser_esm/* default.div */.ZP.div(_templateObject10());
var CardParagraph = styled_components_browser_esm/* default.p */.ZP.p(_templateObject11(), colors.B1);
var CardComment = styled_components_browser_esm/* default.p */.ZP.p(_templateObject12());
var Image = styled_components_browser_esm/* default.div */.ZP.div(_templateObject13());

;// CONCATENATED MODULE: ./src/pages/contact-us/contact-us.png
/* harmony default export */ var contact_us = ({"src":"https://img1.tidb.net/_next/static/media/contact-us.7de46ea4.png","height":2412,"width":5549,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAOVBMVEXXmXfQfJQAC4kAE4/gsm5hWKNtaJvCdHTRknzBsa47KTzzvmOjkUPUPTy/LUSik3EdNYRTV6npuafOwRdxAAAAE3RSTlMz2hMIarRfc3i6oaef4pm4m9XI1Gfm/wAAAAlwSFlzAAALEwAACxMBAJqcGAAAACNJREFUCJljYGBn5+BgY2FgYOBlFOIU5GdgYGbl4uHmE2ACAAiUALuZcs+aAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./src/pages/contact-us/index.page.js
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}








var Page = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CommunityHead */.Wh, {
                title: "\u8054\u7CFB\u6211\u4EEC",
                description: "\u6211\u4EEC\u4E3A\u6BCF\u4E00\u4F4D\u6765\u5230 TiDB \u793E\u533A\u7684\u5C0F\u4F19\u4F34\u63D0\u4F9B\u5E2E\u52A9\u3002\u5982\u679C\u4F60\u9047\u5230\u6280\u672F\u95EE\u9898\uFF0C\u60F3\u8981\u83B7\u5F97\u5546\u4E1A\u652F\u6301\uFF0C\u6216\u8005\u662F\u60F3\u8FDB\u884C\u793E\u533A\u5408\u4F5C\uFF0C\u6B22\u8FCE\u5728\u8FD9\u91CC\u8054\u7CFB\u6211\u4EEC\uFF01",
                keyoword: [
                    "TiDB \u793E\u533A",
                    "\u8054\u7CFB\u6211\u4EEC",
                    "\u54A8\u8BE2",
                    "\u63D0\u95EE",
                    "\u5546\u4E1A\u652F\u6301",
                    "\u793E\u533A\u5408\u4F5C"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(layouts/* CoreLayout */.N, {
                backgroundColor: "#e9eaee",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                            children: "Hello! \u6B22\u8FCE\u6765\u5230 TiDB \u793E\u533A\uFF0C\u6709\u4EC0\u4E48\u80FD\u5E2E\u5230\u4F60\uFF1F"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(List, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card, {
                                    $color: "#F8C200",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CardTitle, {
                                            children: "\u9047\u5230\u6280\u672F\u95EE\u9898"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardGroup, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CardParagraph, {
                                                    children: "\u4F60\u53EF\u4EE5\u5728\u8BBA\u575B\u548C 2w+ \u793E\u533A\u5C0F\u4F19\u4F34\u4E92\u76F8\u4EA4\u6D41\u95EE\u9898"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CardParagraph, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, {
                                                        href: "https://asktug.com/new-topic",
                                                        children: "> \u53BB\u53D1\u5E16"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardGroup, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CardParagraph, {
                                                    children: "\u5982\u679C\u4F60\u60F3\u770B\u770B\u522B\u4EBA\u662F\u5426\u9047\u5230\u76F8\u4F3C\u7684\u95EE\u9898\uFF0C\u5E76\u4E14\u5DF2\u6709\u4E86\u89E3\u51B3\u65B9\u6848"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CardParagraph, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, {
                                                        href: "https://search.asktug.com/",
                                                        children: "> \u53BB\u641C\u7D22"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card, {
                                    $color: "#F15A24",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CardTitle, {
                                            children: "\u5546\u4E1A\u652F\u6301"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CardParagraph, {
                                            children: "\u60F3\u8981\u83B7\u5F97\u5546\u4E1A\u4E13\u5BB6\u4EA7\u54C1\u6700\u9AD8\u54CD\u5E94\u7EA7\u522B 7*24 \u652F\u6301\u670D\u52A1"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CardComment, {
                                            children: "\u89C4\u5212/\u5B9E\u65BD/\u4E3B\u52A8\u5F0F\u5DE1\u68C0/\u6545\u969C\u534F\u67E5/\u77E5\u8BC6\u8F6C\u79FB/\u91CD\u8981\u65F6\u671F\u4FDD\u969C"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CardParagraph, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, {
                                                href: "https://cn.pingcap.com/contact/?utm_source=tidb-community&utm_medium=referral",
                                                children: "> \u8054\u7CFB PingCAP"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card, {
                                    $color: "#E30C34",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CardTitle, {
                                            children: "\u793E\u533A\u5408\u4F5C"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CardParagraph, {
                                            children: "TiDB \u793E\u533A\u5DF2\u7ECF\u548C\u591A\u5BB6\u793E\u533A\u5EFA\u7ACB\u4E86\u5408\u4F5C\u5173\u7CFB\uFF0C\u5982\uFF1A\u601D\u5426\u3001\u5F00\u6E90\u4E2D\u56FD\u3001\u5F00\u6E90\u793E\u3001infoQ \u7B49\u3002"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CardParagraph, {
                                            children: "\u6B22\u8FCE\u6765\u548C\u6211\u4EEC\u4E00\u8D77\u505A\u66F4\u591A\u6709\u610F\u601D\u7684\u4E8B\uFF01"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CardParagraph, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, {
                                                href: "/contact-us/cooperation",
                                                children: "> \u586B\u5199\u5408\u4F5C\u8868\u5355"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card, {
                                    $color: "#BE1D32",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CardTitle, {
                                            children: "\u4E91\u6570\u636E\u5E93 TiDB"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CardParagraph, {
                                            children: "TiDB \u4E0A\u7EBF\u963F\u91CC\u4E91\u5FC3\u9009\u5546\u57CE\uFF0C\u5E26\u6765\u65B0\u4E00\u4EE3 HTAP \u6570\u636E\u5E93\u7684\u4E91\u7AEF\u4F53\u9A8C\uFF0C\u4EAB\u53D7 PingCAP \u539F\u5382\u670D\u52A1\u652F\u6301\u3002"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CardParagraph, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, {
                                                href: "https://cn.pingcap.com/events/tidb-on-aliyun/?utm_source=tidb-community&utm_medium=referral",
                                                children: "> \u4E86\u89E3\u66F4\u591A\u8BE6\u60C5"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), _objectSpread({}, contact_us, {
                                width: 600,
                                height: 260,
                                alt: ""
                            }))
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var index_page = (Page);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,9774,2888,179], function() { return __webpack_exec__(96033); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);